/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var icons = require('magcore-theme/icons');


if (  TARGET === 'android-stb' || TARGET === 'android-app' ) {
    module.exports = {
        view: 'theme-icon',
        favorite: icons.FAVORITE,
        favoriteActive: icons.FAVORITE_ACTIVE + ' active',
        record: icons.PLAY,
        tvGuide: icons.MENU
    };
} else {
    module.exports = {
        view: icons.RC_F1,
        favorite: icons.RC_F3,
        favoriteActive: icons.RC_F3,
        record: icons.PLAY,
        tvGuide: icons.RC_F4
    };
}
